/**
 * Light / dark theme of the panel. «Sistema» follows the computer (the tokens already answer to
 * prefers-color-scheme); «Claro» and «Oscuro» pin it with `data-theme` on <html>.
 * Kept per browser in localStorage: it is a preference of this device, not of the account.
 */
export type ThemeChoice = 'system' | 'light' | 'dark';

const KEY = 'admin.theme';

export function storedTheme(): ThemeChoice {
  try {
    const v = localStorage.getItem(KEY);
    return v === 'light' || v === 'dark' ? v : 'system';
  } catch {
    // private mode or blocked storage: the computer's own mode
    return 'system';
  }
}

export function applyTheme(choice: ThemeChoice) {
  const root = document.documentElement;
  if (choice === 'system') delete root.dataset.theme;
  else root.dataset.theme = choice;
}

export function saveTheme(choice: ThemeChoice) {
  try {
    if (choice === 'system') localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, choice);
  } catch {
    // not kept: it still applies until the tab is closed
  }
  applyTheme(choice);
}
